import Header from "app/pages/Header/Header";

export default props => <Header {...props} />;
